import React, { useEffect, useState, useRef } from 'react';
import {
    Button,
    Card,
    Col,
    DatePicker,
    Form,
    Checkbox,
    InputNumber,
    message,
    Table,
    Row,
    Select,
    Input,
    Modal,
    Space,
    Pagination,
} from 'antd';
import { useGetAreaQuery, useGetEndPortQuery, useGetStartPortQuery } from '@/store/apiSlice';
import { createJsonOptions } from '@/scripts/utils';
import { FORM_RULE_REQUIRED } from '@/scripts/config';
import dayjs from 'dayjs';
import ajax from '@/scripts/ajax';
import axios from 'axios';
import _ from 'lodash';
import { DownOutlined, UpOutlined } from '@ant-design/icons';
const defaultValue = {
    // cargo_details: 'Fabrics, textiles',
    send_num: 1,
    // import_service_mode: 'CY',
    account_name: '-1',
    commodity_key: '-1',
    weight: Math.floor(Math.random() * 1001) + 20500,
    box_type: '40',
    destination_service_mode: 'CY',
    container_quantity: 1,
    order_date: dayjs(),
};
// 重量范围默认配置
const DEFAULT_WEIGHT_RANGE = {
    single: { min: 20500, max: 21500 },
    multi: { min: 18000, max: 20000 },
};
// 缓存版本号
const WEIGHT_RANGE_CACHE_VERSION = 3;
const WEIGHT_RANGE_STORAGE_KEY = 'hpl_weight_range_config';
// 航线卡片排序
const sortRoutes = (routes) => {
    if (!Array.isArray(routes) || routes.length <= 1) return routes || [];

    return routes
        .map((route, idx) => ({ route, idx }))
        .sort((a, b) => {
            const aTime = dayjs(a.route.departureDateTime).valueOf();
            const bTime = dayjs(b.route.departureDateTime).valueOf();
            const aValid = !Number.isNaN(aTime);
            const bValid = !Number.isNaN(bTime);

            // 时间无效的放最后
            if (aValid !== bValid) return aValid ? -1 : 1;
            if (aTime !== bTime) return aTime - bTime;

            // 时间相同 → 保持原顺序
            return a.idx - b.idx;
        })
        .map((x) => x.route);
};
export default function HplBookOrderListForm(props) {
    const { id, cache } = props;
    const [allOrderList, setAllOrderList] = useState([]);
    const [accountTags, setAccountTags] = useState(['-1']);
    const [accountStatus, setAccountStatus] = useState({});
    const pollingTimers = useRef({});
    const [expandedMap, setExpandedMap] = useState({});
    const [form] = Form.useForm();
    const [loadingQuotation, setLoadingQuotation] = useState(false);
    const [bookingLoadingMap, setBookingLoadingMap] = useState({});
    const [refreshingMap, setRefreshingMap] = useState({});
    const pollingTimerRef = useRef(null);
    const { data: startPortOptions } = useGetStartPortQuery(1);
    const { data: endPortOptions } = useGetEndPortQuery(1);
    const [orderList, setOrderList] = useState([]);
    // 分页
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(50);
    const [total, setTotal] = useState(0);
    const [accountOptions, setAccountOptions] = useState([]);
    const [accountLoading, setAccountLoading] = useState(false);
    // 搜索
    const [searchParams, setSearchParams] = useState({});
    // const { data: areaOptions } = useGetAreaQuery();
    const [usaBookAccounts, setUsaBookAccounts] = useState([]);
    const [usaAccountsLoading, setUsaAccountsLoading] = useState(false);
    const [formDefaultValue, setFormDefaultValue] = useState(null);
    const [selectedRouteMap, setSelectedRouteMap] = useState({});
    const [commodityOptions, setCommodityOptions] = useState([]);
    const [commodityLoading, setCommodityLoading] = useState(false);
    const [bookWeightGroups, setBookWeightGroups] = useState([]);
    // 订舱弹窗
    const [bookModalOpen, setBookModalOpen] = useState(false);
    const [bookModalItem, setBookModalItem] = useState(null);
    const [bookForm] = Form.useForm();
    const watchedQty = Form.useWatch('container_quantity', bookForm);
    const watchedSendNum = Form.useWatch('send_num', bookForm);
    // 重量范围配置（优先取本地缓存）
    const [weightRangeConfig, setWeightRangeConfig] = useState(() => {
        try {
            const cached = localStorage.getItem(WEIGHT_RANGE_STORAGE_KEY);
            if (cached) {
                const parsed = JSON.parse(cached);
                // 版本不匹配 → 丢弃旧缓存，用新的 DEFAULT_WEIGHT_RANGE
                if (parsed?.version === WEIGHT_RANGE_CACHE_VERSION && parsed?.single && parsed?.multi) {
                    return { single: parsed.single, multi: parsed.multi };
                }
            }
        } catch (e) {
            // ignore
        }
        return DEFAULT_WEIGHT_RANGE;
    });
    const [weightRangeModalOpen, setWeightRangeModalOpen] = useState(false);
    const [weightRangeForm] = Form.useForm();
    // 批量订舱
    const [batchBookLoading, setBatchBookLoading] = useState(false);
    const [batchBookModalOpen, setBatchBookModalOpen] = useState(false);
    const [batchBookForm] = Form.useForm();
    // 创建自动订舱任务弹窗
    const [autoBookModalOpen, setAutoBookModalOpen] = useState(false);
    const [autoBookRouteId, setAutoBookRouteId] = useState(null);
    const [autoBookForm] = Form.useForm();
    const [autoBookLoading, setAutoBookLoading] = useState(false);
    // const handleRouteSelect = (itemId, route) => {
    //     setSelectedRouteMap((prev) => ({
    //         ...prev,
    //         [itemId]: route.id,
    //     }));
    // };

    // 生成箱子的重量数组
    const generateBoxWeights = (qty) => {
        const q = Math.max(1, Math.floor(Number(qty) || 1));
        const rand = (range) => {
            const min = Number(range?.min) || 0;
            const max = Number(range?.max) || min;
            if (max <= min) return min;
            return Math.floor(Math.random() * (max - min + 1)) + min;
        };

        if (q === 1) {
            return [rand(weightRangeConfig.single)]; // 单箱：20500~21500
        }

        // 多箱：60% 用 single 范围，40% 用 multi 范围（四舍五入）
        const sixtyCount = Math.round(q * 0.6);
        const fortyCount = q - sixtyCount;
        const boxes = [];
        for (let i = 0; i < sixtyCount; i++) boxes.push(rand(weightRangeConfig.single));
        for (let i = 0; i < fortyCount; i++) boxes.push(rand(weightRangeConfig.multi));
        return boxes;
    };

    //返回总和
    const generateWeightByQty = (qty) => {
        return generateBoxWeights(qty).reduce((s, v) => s + v, 0);
    };

    // 单次提交用一个随机重量（qty 个箱子重量求和）
    const generateOneWeight = (qty) => {
        return generateBoxWeights(qty).reduce((s, v) => s + v, 0);
    };

    // 生成 count 个随机重量（一维数组，用于 tags 展示）
    const generateWeightGroups = (qty, count) => {
        const q = Math.max(1, Math.floor(Number(qty) || 1));
        const n = Math.max(1, Math.floor(Number(count) || 1));
        return Array.from({ length: n }, () => generateBoxWeights(q));
    };
    const handleRouteSelect = (itemId, route) => {
        // 不可预订直接忽略点击
        if (!route.bookable) return;

        setSelectedRouteMap((prev) => {
            const currentSelectedId = prev[itemId];
            if (currentSelectedId === route.id) {
                const newMap = { ...prev };
                delete newMap[itemId];
                return newMap;
            } else {
                return { ...prev, [itemId]: route.id };
            }
        });
    };

    useEffect(() => {
        let finalValue = { ...defaultValue, weight: generateWeightByQty(defaultValue.container_quantity) };
        setFormDefaultValue(finalValue);
        return () => {
            Object.keys(pollingTimers.current).forEach((key) => {
                clearInterval(pollingTimers.current[key]);
            });
            pollingTimers.current = {};
            if (pollingTimerRef.current) {
                clearInterval(pollingTimerRef.current);
            }
        };
    }, [cache]);

    // 监听分页变化
    useEffect(() => {
        if (formDefaultValue) {
            appointmentNumberList(currentPage, pageSize, searchParams);
        }
    }, [currentPage, pageSize, formDefaultValue, searchParams]);
    useEffect(() => {
        // 获取账号列表
        setAccountLoading(true);
        axios
            .get('http://183.249.91.105:15600/hpl/accounts')
            .then((res) => {
                const options = res.data.map((item) => ({ label: item, value: item }));
                setAccountOptions([{ label: '-1', value: '-1' }, ...options]);
            })
            .catch((err) => {
                console.error('获取账号列表失败', err);
                message.error('获取账号列表失败');
            })
            .finally(() => setAccountLoading(false));
    }, []);
    useEffect(() => {
        setUsaAccountsLoading(true);
        axios
            .get('http://183.249.91.105:15600/hpl/accounts/book')
            .then((res) => {
                setUsaBookAccounts(Array.isArray(res.data) ? res.data : []);
            })
            .catch((err) => {
                console.error('获取美线账号列表失败', err);
                message.error('获取美线账号列表失败');
            })
            .finally(() => setUsaAccountsLoading(false));
    }, []);
    useEffect(() => {
        // 获取品名列表
        setCommodityLoading(true);
        axios
            .get('http://183.249.91.105:15600/hpl/commodities')
            .then((res) => {
                const items = Array.isArray(res.data?.items) ? res.data.items : [];
                const options = items.map((item) => ({
                    label: `${item.cargo_description} - ${item.hs_code}`,
                    value: `${item.cargo_description}||${item.hs_code}`,
                }));
                setCommodityOptions([{ label: '-1', value: '-1' }, ...options]);
            })
            .catch((err) => {
                console.error('获取品名列表失败', err);
                message.error('获取品名列表失败');
            })
            .finally(() => setCommodityLoading(false));
    }, []);
    const appointmentNumberList = (page = currentPage, perPage = pageSize, extraParams = searchParams) => {
        axios
            .get('http://183.249.91.105:15600/hpl/quotation-orders/page', {
                params: {
                    page: page,
                    per_page: perPage,
                    ...extraParams, // 合并搜索参数
                },
            })
            .then((res) => {
                if (res.data && res.data.data) {
                    setAllOrderList(res.data.data);
                    setOrderList(res.data.data);
                    setTotal(res.data.total || 0);
                }
            })
            .catch((err) => {
                console.log(err, 'err');
            });
    };
    const orderColumns = [
        { title: 'trace_id', dataIndex: 'trace_id', key: 'trace_id', align: 'center' },
        { title: '起始港', dataIndex: 'originlocation', key: 'originlocation', align: 'center' },
        { title: '目的港', dataIndex: 'destinationlocation', key: 'destinationlocation', align: 'center' },
        { title: '账号', dataIndex: 'username', key: 'username', align: 'center' },
        { title: 'quantity', dataIndex: 'quantity', key: 'quantity', align: 'center' },
        { title: 'bookingnumber', dataIndex: 'bookingnumber', key: 'bookingnumber', align: 'center' },
        { title: '开航时间', dataIndex: 'earlytime', key: 'earlytime', align: 'center' },
        { title: '结束时间', dataIndex: 'endtime', key: 'endtime', align: 'center' },
        { title: '价格', dataIndex: 'price', key: 'price', align: 'center' },
        { title: '总价', dataIndex: 'total_price', key: 'total_price', align: 'center' },
        {
            title: '订舱时间',
            dataIndex: 'book_time',
            key: 'book_time',
            align: 'center',
            render: (text) => (text ? dayjs(text).format('YYYY-MM-DD HH:mm:ss') : '-'),
        },
    ];
    const handleSubmit = () => {
        form.validateFields()
            .then((formValue) => {
                const isUsa = !!formValue.is_usa;

                // 只有非 is_usa 场景才要求必须选择账号
                if (!isUsa && accountTags.length === 0) {
                    message.error('请至少输入一个账号');
                    return;
                }

                // 决定本次要使用的账号列表
                let accountsToUse;
                if (isUsa) {
                    // 勾选 is_usa：从接口拉到的美线账号里随机取一个
                    if (usaBookAccounts.length === 0) {
                        message.error('美线账号列表为空，请稍后重试');
                        return;
                    }
                    const randomIdx = Math.floor(Math.random() * usaBookAccounts.length);
                    accountsToUse = [usaBookAccounts[randomIdx]];
                } else {
                    accountsToUse = accountTags;
                }

                setLoadingQuotation(true);

                // 初始化每个账号的状态为 pending
                const initStatus = {};
                accountsToUse.forEach((acc) => (initStatus[acc] = 'pending'));
                setAccountStatus(initStatus);

                const {
                    start_port_en_name,
                    end_port_en_name,
                    box_type,
                    destination_service_mode,
                    container_quantity,
                    order_date,
                    weight,
                    is_usa,
                    commodity_key, // 单独取出，不进 rest
                    ...rest
                } = formValue;

                const baseTaskInfo = {
                    start_port_en_name,
                    end_port_en_name,
                    box_type,
                    destination_service_mode,
                    container_quantity,
                    weight,
                    order_date: dayjs(order_date).format('YYYY-MM-DD'),
                };
                // 品名非必填
                if (commodity_key === '-1') {
                    // 选 -1：从真实品名里随机取一个（排除 -1 本身）
                    const realOptions = commodityOptions.filter((opt) => opt.value !== '-1');
                    if (realOptions.length === 0) {
                        message.error('品名列表为空，无法随机选择');
                        setLoadingQuotation(false); // 关键：提前 return 前复位 loading
                        return;
                    }
                    const randomIdx = Math.floor(Math.random() * realOptions.length);
                    const [cargo_description, hs_code] = realOptions[randomIdx].value.split('||');
                    baseTaskInfo.cargo_description = cargo_description;
                    baseTaskInfo.hs_code = hs_code;
                } else if (commodity_key) {
                    // 选了具体品名
                    const [cargo_description, hs_code] = commodity_key.split('||');
                    baseTaskInfo.cargo_description = cargo_description;
                    baseTaskInfo.hs_code = hs_code;
                }
                // 对每个账号发起提交
                accountsToUse.forEach((account) => {
                    let finalAccount = account;

                    if (!isUsa && account === '-1') {
                        const realOptions = accountOptions.filter((opt) => opt.value !== '-1');
                        if (realOptions.length === 0) {
                            message.error('没有可用的账号');
                            return;
                        }
                        const randomIndex = Math.floor(Math.random() * realOptions.length);
                        finalAccount = realOptions[randomIndex].value;
                    }

                    const value = {
                        task_type: 'hpl_qq_quotation_number',
                        ignore_is_run: true,
                        send_num: 1,
                        task_info: {
                            ...baseTaskInfo,
                            account_name: finalAccount,
                        },
                        ...rest,
                    };

                    axios
                        .post('http://183.249.91.105:15600/query/submit', value)
                        .then((response) => {
                            const traceIds = response.data.trace_ids[0];
                            if (traceIds && traceIds.length > 0) {
                                pollTaskStatus(
                                    traceIds,
                                    account,
                                    () => {
                                        setAccountStatus((prev) => {
                                            const newStatus = { ...prev, [account]: 'success' };
                                            checkAllDone(newStatus);
                                            return newStatus;
                                        });
                                    },
                                    () => {
                                        setAccountStatus((prev) => {
                                            const newStatus = { ...prev, [account]: 'failed' };
                                            checkAllDone(newStatus);
                                            return newStatus;
                                        });
                                    },
                                );
                            } else {
                                setAccountStatus((prev) => {
                                    const newStatus = { ...prev, [account]: 'failed' };
                                    checkAllDone(newStatus);
                                    return newStatus;
                                });
                            }
                        })
                        .catch((err) => {
                            message.error(`账号 ${account} 提交失败`);
                            setAccountStatus((prev) => {
                                const newStatus = { ...prev, [account]: 'failed' };
                                checkAllDone(newStatus);
                                return newStatus;
                            });
                        });
                });
            })
            .catch((err) => {
                console.log(err);
            });
    };
    const handleSearch = () => {
        const formValues = form.getFieldsValue();
        const params = {};

        // 起始港
        if (formValues.start_port_en_name) {
            params.origin = formValues.start_port_en_name;
        }
        // 目的港
        if (formValues.end_port_en_name) {
            params.destination = formValues.end_port_en_name;
        }

        // 账号：多选，逗号隔开
        const accounts = accountTags;
        const hasAccountFilter = accounts.length > 0 && !(accounts.length === 1 && accounts[0] === '-1');
        if (hasAccountFilter) {
            params.username = accounts.join(',');
        }

        // 更新搜索条件并回到第一页
        setSearchParams(params);
        if (currentPage !== 1) {
            setCurrentPage(1);
        }
    };
    // 打开批量订舱弹窗
    const openBatchBookModal = () => {
        batchBookForm.setFieldsValue({ send_num: 1 });
        setBatchBookModalOpen(true);
    };

    // 批量订舱提交
    const handleBatchBookModalOk = () => {
        batchBookForm
            .validateFields()
            .then(({ send_num }) => {
                form.validateFields()
                    .then((formValue) => {
                        const {
                            start_port_en_name,
                            end_port_en_name,
                            box_type,
                            destination_service_mode,
                            container_quantity,
                            order_date,
                            weight,
                            commodity_key,
                        } = formValue;

                        if (commodity_key === '-1') {
                            const realOptions = commodityOptions.filter((opt) => opt.value !== '-1');
                            if (realOptions.length === 0) {
                                message.error('品名列表为空，无法随机选择');
                                return;
                            }
                        }

                        const taskInfo = {
                            start_port_en_name,
                            end_port_en_name,
                            box_type,
                            destination_service_mode,
                            container_quantity,
                            weight,
                            order_date: order_date ? dayjs(order_date).format('YYYY-MM-DD') : undefined,
                        };

                        // 选了具体品名 → 固定使用，不做随机
                        if (commodity_key && commodity_key !== '-1') {
                            const [cargo_description, hs_code] = commodity_key.split('||');
                            taskInfo.cargo_description = cargo_description;
                            taskInfo.hs_code = hs_code;
                        }

                        setBatchBookModalOpen(false);
                        submitBatchBook(taskInfo, send_num, commodity_key);
                    })
                    .catch((err) => console.log(err));
            })
            .catch((err) => console.log(err));
    };
    // 循环提交 send_num 次
    const submitBatchBook = (taskInfo, sendNum, commodityKey) => {
        // 过滤账号（排除 '-1'）
        const accountPool = accountOptions.map((opt) => opt.value).filter((val) => val !== '-1');
        if (accountPool.length === 0) {
            message.error('账号列表为空，无法随机选择账号');
            return;
        }

        // 品名（排除 '-1'）
        const needRandomCommodity = commodityKey === '-1';
        const realCommodityOptions = commodityOptions.filter((opt) => opt.value !== '-1');
        if (needRandomCommodity && realCommodityOptions.length === 0) {
            message.error('品名列表为空，无法随机选择');
            return;
        }

        const totalCount = Math.max(1, Number(sendNum) || 1);
        let doneCount = 0;
        let successCount = 0;
        let failCount = 0;

        setBatchBookLoading(true);

        const onOneDone = (ok) => {
            doneCount += 1;
            if (ok) successCount += 1;
            else failCount += 1;

            if (doneCount >= totalCount) {
                setBatchBookLoading(false);
                if (successCount > 0) message.success(`批量获取约号成功 ${successCount} 次`);
                if (failCount > 0) message.error(`批量获取约号失败 ${failCount} 次`);
                appointmentNumberList();
            }
        };

        for (let i = 0; i < totalCount; i++) {
            const subKey = `batch_${Date.now()}_${i}`;

            // 账号随机
            const randomAccount = accountPool[Math.floor(Math.random() * accountPool.length)];

            // 品名随机
            let cargo_description = taskInfo.cargo_description;
            let hs_code = taskInfo.hs_code;
            if (needRandomCommodity) {
                const randomIdx = Math.floor(Math.random() * realCommodityOptions.length);
                [cargo_description, hs_code] = realCommodityOptions[randomIdx].value.split('||');
            }

            const value = {
                task_type: 'hpl_qq_quotation_number',
                ignore_is_run: true,
                task_info: {
                    ...taskInfo,
                    cargo_description,
                    hs_code,
                    account_name: randomAccount,
                },
            };

            axios
                .post('http://183.249.91.105:15600/query/submit', value)
                .then((response) => {
                    const traceIds = response.data?.trace_ids?.[0];
                    if (traceIds && traceIds.length > 0) {
                        pollTaskStatusForBooking(
                            traceIds,
                            subKey,
                            () => onOneDone(true),
                            () => onOneDone(false),
                        );
                    } else {
                        onOneDone(false);
                    }
                })
                .catch((err) => {
                    console.error(err, 'err');
                    onOneDone(false);
                });
        }
    };
    const checkAllDone = (statusMap) => {
        const allDone = Object.values(statusMap).every((status) => status !== 'pending');
        if (allDone) {
            Object.keys(statusMap).forEach((acc) => {
                if (pollingTimers.current[acc]) {
                    clearInterval(pollingTimers.current[acc]);
                    delete pollingTimers.current[acc];
                }
            });

            const successCount = Object.values(statusMap).filter((s) => s === 'success').length;
            const failCount = Object.values(statusMap).filter((s) => s === 'failed').length;
            if (successCount > 0) {
                message.success(`${successCount} 个账号获取约号成功`);
            }
            if (failCount > 0) {
                message.error(`${failCount} 个账号获取约号失败`);
            }
            setLoadingQuotation(false);
        }
    };
    const pollTaskStatus = (traceIds, account, onSuccess, onError) => {
        const key = account || 'single';
        // 清除该账号之前的轮询
        if (pollingTimers.current[key]) {
            clearInterval(pollingTimers.current[key]);
            delete pollingTimers.current[key];
        }

        const checkStatus = () => {
            axios
                .get(`http://183.249.91.105:15600/hpl/quotation-orders/trace/${traceIds}`)
                .then((res) => {
                    const status = res.data?.status;
                    if (status === 'SUCCESS') {
                        appointmentNumberList();
                        if (onSuccess) onSuccess();
                        clearInterval(pollingTimers.current[key]);
                        delete pollingTimers.current[key];
                    } else if (status === 'PENDING') {
                        // 继续轮询
                    } else {
                        message.error(`${key === 'single' ? '' : `账号 ${key} `}操作失败，请稍后重试`);
                        if (onError) onError();
                        clearInterval(pollingTimers.current[key]);
                        delete pollingTimers.current[key];
                    }
                })
                .catch((err) => {
                    message.error(`${key === 'single' ? '' : `账号 ${key} `}查询状态失败`);
                    if (onError) onError();
                    clearInterval(pollingTimers.current[key]);
                    delete pollingTimers.current[key];
                });
        };

        checkStatus();
        pollingTimers.current[key] = setInterval(checkStatus, 1000);
    };
    const pollTaskStatusForBooking = (traceIds, itemKey, onSuccess, onError) => {
        const key = `booking_${itemKey}`; // 使用唯一标识
        if (pollingTimers.current[key]) {
            clearInterval(pollingTimers.current[key]);
            delete pollingTimers.current[key];
        }

        const checkStatus = () => {
            axios
                .get(`http://183.249.91.105:15600/hpl/quotation-orders/trace/${traceIds}`)
                .then((res) => {
                    const status = res.data?.status;
                    const failedReason = res.data?.failed_reason || '订舱失败，请稍后重试';
                    const traceId = res.data?.trace_id || traceIds;
                    if (status === 'SUCCESS') {
                        appointmentNumberList();
                        if (onSuccess) onSuccess();
                        clearInterval(pollingTimers.current[key]);
                        delete pollingTimers.current[key];
                    } else if (status === 'PENDING') {
                        // 继续轮询
                    } else if (status === 'FAILED') {
                        // 状态为 ERROR 或其他失败情况 → 弹窗
                        Modal.error({
                            title: '订舱失败',
                            content: (
                                <div>
                                    <p>
                                        <strong>失败原因：</strong>
                                        {failedReason}
                                    </p>
                                    <p>
                                        <strong>Trace ID：</strong>
                                        {traceId}
                                    </p>
                                </div>
                            ),
                        });
                        if (onError) onError();
                        clearInterval(pollingTimers.current[key]);
                        delete pollingTimers.current[key];
                    } else {
                        // 兜底：其他非预期状态也按失败处理
                        Modal.error({
                            title: '订舱失败',
                            content: (
                                <div>
                                    <p>
                                        <strong>状态：</strong>
                                        {status || '未知'}
                                    </p>
                                    <p>
                                        <strong>失败原因：</strong>
                                        {failedReason}
                                    </p>
                                    <p>
                                        <strong>Trace ID：</strong>
                                        {traceId}
                                    </p>
                                </div>
                            ),
                        });
                        if (onError) onError();
                        clearInterval(pollingTimers.current[key]);
                        delete pollingTimers.current[key];
                    }
                })
                .catch((err) => {
                    message.error('查询状态失败');
                    if (onError) onError();
                    clearInterval(pollingTimers.current[key]);
                    delete pollingTimers.current[key];
                });
        };

        checkStatus();
        pollingTimers.current[key] = setInterval(checkStatus, 1000);
    };
    const handleReset = () => {
        form.resetFields();
        // 重置表单字段，但不要设置账号默认值（账号独立管理）
        form.setFieldsValue({
            start_port_en_name: undefined,
            end_port_en_name: undefined,
            box_type: undefined,
            destination_service_mode: 'CY',
            container_quantity: undefined,
            order_date: undefined,
            weight: generateWeightByQty(1),
            is_usa: false,
            commodity_key: '-1',
        });
        setAccountTags(['-1']); // 重置账号标签
        setSearchParams({});
        if (currentPage === 1) {
            appointmentNumberList(1, pageSize); // 如果本来就在第 1 页，手动请求一次刷新
        } else {
            setCurrentPage(1); // 如果不在第 1 页，回到第 1 页触发 useEffect
        }
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };
    const handleBook = (item, weightGroups, containerQuantity, orderDate) => {
        const itemKey = item.id || item.trace_id;
        setBookingLoadingMap((prev) => ({ ...prev, [itemKey]: true }));

        const selectedRouteId = selectedRouteMap[item.id];
        const qty = Math.max(1, Math.floor(Number(containerQuantity) || Number(item.task_info.container_quantity) || 1));
        const finalOrderDate = orderDate ? dayjs(orderDate).format('YYYY-MM-DD') : item.task_info.order_date;
        const totalCount = Math.max(1, weightGroups.length);

        let doneCount = 0;
        let successCount = 0;
        let failCount = 0;

        const onOneDone = (ok) => {
            doneCount += 1;
            if (ok) successCount += 1;
            else failCount += 1;
            if (doneCount >= totalCount) {
                setBookingLoadingMap((prev) => ({ ...prev, [itemKey]: false }));
                if (successCount > 0) message.success(`订舱成功 ${successCount} 次`);
                if (failCount > 0 && totalCount === 1) message.error('订舱失败');
            }
        };

        for (let i = 0; i < totalCount; i++) {
            const subKey = `${itemKey}_${i}_${Date.now()}`;
            const groupWeights = weightGroups[i];

            const value = {
                task_type: 'hpl_qq_shipment_number',
                ignore_is_run: true,
                task_info: {
                    start_port_en_name: item.task_info.startPort.name,
                    end_port_en_name: item.task_info.endPort.name,
                    box_type: item.task_info.box.box,
                    account_name: item.account_name,
                    container_quantity: qty,
                    container_weights: groupWeights,
                    order_date: finalOrderDate,
                    cargo_description: item.task_info.cargo_description,
                    hs_code: item.task_info.hs_code,
                    quotation_number: item.quotation_number,
                    route_id: selectedRouteId || null,
                },
            };

            axios
                .post('http://183.249.91.105:15600/query/submit', value)
                .then((response) => {
                    const traceIds = response.data.trace_ids[0];
                    if (traceIds && traceIds.length > 0) {
                        pollTaskStatusForBooking(
                            traceIds,
                            subKey,
                            () => onOneDone(true),
                            () => onOneDone(false),
                        );
                    } else {
                        onOneDone(false);
                    }
                })
                .catch((err) => {
                    console.error(err, 'err');
                    onOneDone(false);
                });
        }
    };
    const openBookModal = (item) => {
        const rawQty = item?.task_info?.container_quantity;
        const defaultQty = rawQty && rawQty !== '-' && !isNaN(Number(rawQty)) && Number(rawQty) > 0 ? Number(rawQty) : 1;
        setBookModalItem(item);
        bookForm.setFieldsValue({
            send_num: 1,
            container_quantity: defaultQty,
            order_date: dayjs(),
        });
        setBookWeightGroups(generateWeightGroups(defaultQty, 1));
        setBookModalOpen(true);
    };
    // 打开重量范围设置弹窗
    const openWeightRangeModal = () => {
        weightRangeForm.setFieldsValue({
            single_min: weightRangeConfig.single.min,
            single_max: weightRangeConfig.single.max,
            multi_min: weightRangeConfig.multi.min,
            multi_max: weightRangeConfig.multi.max,
        });
        setWeightRangeModalOpen(true);
    };

    // 保存重量范围设置
    const handleWeightRangeModalOk = () => {
        weightRangeForm
            .validateFields()
            .then((values) => {
                const single = { min: Number(values.single_min), max: Number(values.single_max) };
                const multi = { min: Number(values.multi_min), max: Number(values.multi_max) };

                if (single.min > single.max) {
                    message.error('单个箱子：最小值不能大于最大值');
                    return;
                }
                if (multi.min > multi.max) {
                    message.error('多个箱子：最小值不能大于最大值');
                    return;
                }

                const newConfig = { single, multi };
                setWeightRangeConfig(newConfig);
                try {
                    localStorage.setItem(WEIGHT_RANGE_STORAGE_KEY, JSON.stringify({ version: WEIGHT_RANGE_CACHE_VERSION, ...newConfig }));
                } catch (e) {
                    // ignore
                }
                setWeightRangeModalOpen(false);
                message.success('重量范围设置已保存');
            })
            .catch((err) => console.log(err));
    };
    const handleBookModalQtyChange = (value) => {
        const qty = Math.max(1, Math.floor(Number(value) || 1));
        const sendNum = Math.max(1, Math.floor(Number(bookForm.getFieldValue('send_num')) || 1));
        setBookWeightGroups(generateWeightGroups(qty, sendNum));
    };

    const handleBookModalSendNumChange = (value) => {
        const sendNum = Math.max(1, Math.floor(Number(value) || 1));
        const qty = Math.max(1, Math.floor(Number(bookForm.getFieldValue('container_quantity')) || 1));
        setBookWeightGroups(generateWeightGroups(qty, sendNum));
    };
    //弹窗提交
    const handleBookModalOk = () => {
        bookForm.validateFields().then(({ send_num, container_quantity, order_date }) => {
            const item = bookModalItem;
            const needOrderDate = item && !selectedRouteMap[item.id];
            const qty = Math.max(1, Math.floor(Number(container_quantity) || 1));
            const sendNum = Math.max(1, Math.floor(Number(send_num) || 1));

            if (bookWeightGroups.length < sendNum) {
                message.error(`send_num 为 ${sendNum}，至少需要 ${sendNum} 组重量（当前 ${bookWeightGroups.length} 组）`);
                return;
            }
            for (let i = 0; i < sendNum; i++) {
                const group = bookWeightGroups[i] || [];
                if (group.length !== qty) {
                    message.error(`第 ${i + 1} 组需要 ${qty} 个每箱重量（当前 ${group.length} 个）`);
                    return;
                }
                if (group.some((v) => !Number.isFinite(Number(v)) || Number(v) <= 0)) {
                    message.error(`第 ${i + 1} 组存在无效重量`);
                    return;
                }
            }

            const groups = bookWeightGroups.slice(0, sendNum).map((g) => g.map(Number));
            setBookModalOpen(false);
            handleBook(item, groups, qty, needOrderDate ? order_date : undefined);
        });
    };

    const openAutoBookModal = (item) => {
        const selectedRouteId = selectedRouteMap[item.id];
        if (!selectedRouteId) {
            message.warning('请选择一条航线');
            return;
        }

        const rawQty = item?.task_info?.container_quantity;
        const defaultQty = rawQty && rawQty !== '-' && !isNaN(Number(rawQty)) && Number(rawQty) > 0 ? Number(rawQty) : 1;

        setAutoBookRouteId(selectedRouteId);
        autoBookForm.setFieldsValue({
            quotation_number: item.quotation_number || '',
            account_name: item.account_name || '',
            container_quantity: defaultQty,
            max_attempts: '',
            target_success_count: '',
            interval_seconds: '',
        });
        setAutoBookModalOpen(true);
    };

    // 创建自动订舱任务
    const handleAutoBookModalOk = () => {
        autoBookForm
            .validateFields()
            .then((values) => {
                const payload = {
                    quotation_number: values.quotation_number,
                    max_attempts: values.max_attempts,
                    target_success_count: values.target_success_count,
                    interval_seconds: values.interval_seconds,
                    booking_options: {
                        account_name: values.account_name,
                        route_id: autoBookRouteId,
                        container_quantity: values.container_quantity,
                    },
                };

                setAutoBookLoading(true);

                axios
                    .post('http://183.249.91.105:15600/hpl/auto-booking-tasks', payload)
                    .then(() => {
                        message.success('创建自动订舱任务成功');
                        setAutoBookModalOpen(false);
                    })
                    .catch((err) => {
                        console.error('创建自动订舱任务失败', err);
                        const errMsg =
                            err?.response?.data?.message || err?.response?.data?.detail || err?.message || '创建自动订舱任务失败';
                        message.error(errMsg);
                    })
                    .finally(() => {
                        setAutoBookLoading(false);
                    });
            })
            .catch((err) => console.log(err));
    };
    // 点击刷新按钮
    const handleRefreshSchedule = (item) => {
        const itemKey = item.id || item.trace_id;
        const quotationNumber = item.quotation_number;

        if (!quotationNumber) {
            message.error('缺少约号，无法刷新');
            return;
        }

        setRefreshingMap((prev) => ({ ...prev, [itemKey]: true }));

        axios
            .post(`http://183.249.91.105:15600/hpl/quotation-orders/${quotationNumber}/contract-schedule/refresh`)
            .then((response) => {
                const traceId = response.data?.trace_id;
                if (traceId) {
                    pollRefreshTask(traceId, itemKey, quotationNumber);
                } else {
                    message.error('刷新航线失败，未返回 trace_id');
                    setRefreshingMap((prev) => ({ ...prev, [itemKey]: false }));
                }
            })
            .catch((err) => {
                console.error(err, 'refresh schedule err');
                message.error('刷新航线失败');
                setRefreshingMap((prev) => ({ ...prev, [itemKey]: false }));
            });
    };

    // 轮询刷新任务状态
    const pollRefreshTask = (traceId, itemKey, quotationNumber) => {
        const key = `refresh_${itemKey}`;
        if (pollingTimers.current[key]) {
            clearInterval(pollingTimers.current[key]);
            delete pollingTimers.current[key];
        }

        const checkStatus = () => {
            axios
                .get(`http://183.249.91.105:15600/hpl/quotation-orders/trace/${traceId}`)
                .then((res) => {
                    const status = res.data?.status;
                    if (status === 'SUCCESS') {
                        clearInterval(pollingTimers.current[key]);
                        delete pollingTimers.current[key];
                        // 成功后再拉最新订单详情覆盖卡片
                        fetchQuotationOrderDetail(quotationNumber, itemKey);
                    } else if (status === 'PENDING') {
                        // 继续轮询
                    } else {
                        message.error('刷新航线失败');
                        setRefreshingMap((prev) => ({ ...prev, [itemKey]: false }));
                        clearInterval(pollingTimers.current[key]);
                        delete pollingTimers.current[key];
                    }
                })
                .catch((err) => {
                    console.error(err, 'refresh trace err');
                    message.error('查询刷新状态失败');
                    setRefreshingMap((prev) => ({ ...prev, [itemKey]: false }));
                    clearInterval(pollingTimers.current[key]);
                    delete pollingTimers.current[key];
                });
        };

        checkStatus();
        pollingTimers.current[key] = setInterval(checkStatus, 1000);
    };

    // 拉取最新订单详情，覆盖当前卡片数据
    const fetchQuotationOrderDetail = (quotationNumber, itemKey) => {
        axios
            .get(`http://183.249.91.105:15600/hpl/quotation-orders/${quotationNumber}`)
            .then((res) => {
                message.success('获取最新航线数据成功');
                const data = res.data;
                console.log('fetchQuotationOrderDetail data', data);
                if (data) {
                    const mergeById = (order) => {
                        const key = order.id || order.trace_id;
                        return key === itemKey ? { ...order, ...data } : order;
                    };
                    setOrderList((prev) => prev.map(mergeById));
                    setAllOrderList((prev) => prev.map(mergeById));
                }
            })
            .catch((err) => {
                console.error(err, 'fetch quotation order err');
                message.error('获取最新航线数据失败');
            })
            .finally(() => {
                setRefreshingMap((prev) => ({ ...prev, [itemKey]: false }));
            });
    };
    const toggleExpand = (id) => {
        setExpandedMap((prev) => ({ ...prev, [id]: !prev[id] }));
    };
    if (!formDefaultValue) return null;

    return (
        <Form form={form} initialValues={formDefaultValue}>
            <Card>
                <Row gutter={16}>
                    <Col span={6}>
                        <Form.Item label="启始港" name="start_port_en_name" required rules={[FORM_RULE_REQUIRED]}>
                            <Select options={createJsonOptions(startPortOptions)} showSearch allowClear></Select>
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item label="目的港" name="end_port_en_name" required rules={[FORM_RULE_REQUIRED]}>
                            <Select options={createJsonOptions(endPortOptions)} showSearch allowClear></Select>
                        </Form.Item>
                    </Col>
                    {/* <Col span={6}>
                        <Form.Item label="日期" name="order_date">
                            <DatePicker style={{ width: '100%' }} />
                        </Form.Item>
                    </Col> */}
                    <Col span={6}>
                        <Form.Item label="账号" style={{ marginBottom: 0 }}>
                            <Select
                                mode="tags"
                                value={accountTags}
                                onChange={setAccountTags}
                                // style={{ width: '100%' }}
                                tokenSeparators={[',']}
                                maxTagCount={1}
                                // dropdownMatchSelectWidth={false}
                                dropdownStyle={{ minWidth: 200 }}
                                options={accountOptions}
                                loading={accountLoading}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item label="美线" name="is_usa" valuePropName="checked">
                            <Checkbox></Checkbox>
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item label="箱型" name="box_type">
                            <Select options={createJsonOptions(['20', '40', '45'])} showSearch allowClear></Select>
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item label="箱量" name="container_quantity">
                            <InputNumber style={{ width: '100%' }}></InputNumber>
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item label="约号起始日期" name="order_date">
                            <DatePicker style={{ width: '100%' }} />
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item label="重量（Kg）" name="weight">
                            <InputNumber style={{ width: '100%' }}></InputNumber>
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item label="品名" name="commodity_key">
                            <Select
                                options={commodityOptions}
                                showSearch
                                allowClear
                                loading={commodityLoading}
                                optionFilterProp="label"
                                placeholder="请选择品名"
                            />
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item label="目的港服务模式" name="destination_service_mode">
                            <Select options={createJsonOptions(['CY', 'SD'])} showSearch></Select>
                        </Form.Item>
                    </Col>
                </Row>
                <Row style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Col span={6}>
                        <Button onClick={handleReset}>重置</Button>
                    </Col>

                    <Col span={18} style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
                        {/* <Button onClick={openWeightRangeModal}>重量范围设置</Button> */}
                        <Button onClick={openBatchBookModal} type="primary" loading={batchBookLoading}>
                            {batchBookLoading ? '正在批量获取约号…' : '批量获取约号'}
                        </Button>
                        <Button onClick={handleSubmit} type="primary" loading={loadingQuotation}>
                            {loadingQuotation ? '正在获取约号中…' : '获取约号'}
                        </Button>
                        <Button onClick={handleSearch} type="primary">
                            搜索
                        </Button>
                    </Col>
                </Row>
            </Card>
            <Card style={{ marginTop: 2 }}>
                {orderList.map((item) => (
                    <div
                        key={item.id || item.trace_id}
                        className="order-card"
                        style={{
                            border: '1px solid #aaa7a7',
                            borderRadius: 4,
                            padding: '12px 16px',
                            marginBottom: 8,
                            backgroundColor: '#fafafa',
                            transition: 'border-color 0.2s ease',
                            cursor: 'default',
                        }}
                        onMouseEnter={(e) => (e.currentTarget.style.borderColor = '#40a9ff')}
                        onMouseLeave={(e) => (e.currentTarget.style.borderColor = '#aaa7a7')}
                    >
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <div
                                style={{
                                    flex: 1,
                                    display: 'grid',
                                    gridTemplateColumns: 'repeat(4, 1fr)',
                                    gap: '4px 16px',
                                    paddingBottom: 12,
                                }}
                            >
                                <div>
                                    <strong>Trace ID：</strong>
                                    {item.trace_id || '无'}
                                </div>
                                <div>
                                    <strong>起始港：</strong>
                                    {item.task_info?.startPort?.name || '-'}
                                </div>
                                <div>
                                    <strong>目的港：</strong>
                                    {item.task_info?.endPort?.name || '-'}
                                </div>
                                <div>
                                    <strong>箱型：</strong>
                                    {item.task_info?.box?.box || '-'}
                                </div>

                                <div>
                                    <strong>约号：</strong>
                                    {item.quotation_number}
                                </div>

                                <div>
                                    <strong>用户邮箱：</strong>
                                    {item.user_email}
                                </div>
                                <div>
                                    <strong>有效起始：</strong>
                                    {item.valid_from}
                                </div>
                                <div>
                                    <strong>有效截止：</strong>
                                    {item.valid_to}
                                </div>
                                <div>
                                    <strong>创建时间：</strong>
                                    {item.created_at ? dayjs(item.created_at).format('YYYY-MM-DD HH:mm:ss') : '-'}
                                </div>
                                <div>
                                    <strong>离港日期：</strong>
                                    {item.departure_date || '-'}
                                </div>
                                <div>
                                    <strong>重量：</strong>
                                    {item.task_info?.weight || '-'}
                                </div>
                                <div>
                                    <strong>总价：</strong>
                                    {item.total_price || '-'}
                                </div>
                                <div>
                                    <strong>品名：</strong>
                                    {item.task_info?.cargo_description || '-'} - {item.task_info?.hs_code || '-'}
                                </div>
                                <div>
                                    <strong>箱量：</strong>
                                    {item.task_info?.container_quantity || '-'}
                                </div>
                                <div>
                                    <strong>目的港服务模式：</strong>
                                    {item.task_info?.destination_service_mode || '-'}
                                </div>
                            </div>

                            <Space style={{ marginLeft: 16, flexShrink: 0 }} size={8}>
                                <Button
                                    onClick={() => handleRefreshSchedule(item)}
                                    loading={refreshingMap[item.id || item.trace_id] || false}
                                >
                                    {refreshingMap[item.id || item.trace_id] ? '正在刷新…' : '刷新'}
                                </Button>
                                <Button onClick={() => openAutoBookModal(item)}>创建自动订舱任务</Button>
                                <Button
                                    type="primary"
                                    onClick={() => openBookModal(item)}
                                    loading={bookingLoadingMap[item.id || item.trace_id] || false}
                                >
                                    {bookingLoadingMap[item.id || item.trace_id] ? '正在订舱…' : '订舱'}
                                </Button>
                            </Space>
                        </div>
                        {item.contract_schedule?.routes?.length > 0 && (
                            <div style={{ marginTop: 12, borderTop: '1px solid #e8e8e8', paddingTop: 12 }}>
                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12 }}>
                                    {sortRoutes(item.contract_schedule.routes).map((route) => {
                                        const isSelected = selectedRouteMap[item.id] === route.id;
                                        return (
                                            <div
                                                key={route.id}
                                                onClick={() => {
                                                    if (!route.bookable) return;
                                                    handleRouteSelect(item.id, route);
                                                }}
                                                style={{
                                                    padding: '4px 12px',
                                                    border: `1px solid ${isSelected ? '#1890ff' : '#d9d9d9'}`,
                                                    borderRadius: 4,
                                                    cursor: route.bookable ? 'pointer' : 'not-allowed',
                                                    backgroundColor: isSelected ? '#e6f7ff' : '#fff',
                                                    transition: 'all 0.2s',
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    alignItems: 'center',
                                                    minWidth: 120,
                                                }}
                                                onMouseEnter={(e) => {
                                                    if (!isSelected) e.currentTarget.style.borderColor = '#40a9ff';
                                                }}
                                                onMouseLeave={(e) => {
                                                    if (!isSelected) e.currentTarget.style.borderColor = '#d9d9d9';
                                                }}
                                            >
                                                <div>
                                                    <span style={{ fontSize: 12, fontWeight: 500 }}>{route.vesselName}|</span>
                                                    <span style={{ fontSize: 12, fontWeight: 500 }}>{route.voyageNumber}|</span>
                                                    <span style={{ fontSize: 12, fontWeight: 500 }}>
                                                        {/* {dayjs(route.departureDateTime).format('YYYY-MM-DD HH:mm')} */}
                                                        {route.departureDateTime}
                                                    </span>
                                                    {/* <span style={{ fontSize: 12, color: '#888' }}> → </span> */}
                                                </div>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginTop: 2 }}>
                                                    <span
                                                        style={{
                                                            fontSize: 11,
                                                            fontWeight: 500,
                                                            color: route.isDirect ? '#1890ff' : '#faad14',
                                                        }}
                                                    >
                                                        {route.isDirect ? '直达' : '中转'}
                                                    </span>
                                                    <span
                                                        style={{
                                                            fontSize: 11,
                                                            fontWeight: 500,
                                                            color: route.bookable ? '#52c41a' : '#ff4d4f',
                                                        }}
                                                    >
                                                        {route.bookable ? '可订' : '不可订'}
                                                    </span>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        )}
                        {item.orders && item.orders.length > 0 && (
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    marginTop: 12,
                                    borderTop: '1px solid #9b9898',
                                }}
                            >
                                <Button
                                    type="link"
                                    onClick={() => toggleExpand(item.id)}
                                    icon={
                                        expandedMap[item.id] ? (
                                            <UpOutlined style={{ fontSize: 15 }} />
                                        ) : (
                                            <DownOutlined style={{ fontSize: 15 }} />
                                        )
                                    }
                                    style={{ padding: '0 14px', color: '#8b8484' }}
                                />
                                {expandedMap[item.id] && (
                                    <Table
                                        columns={orderColumns}
                                        dataSource={item.orders}
                                        rowKey={(record) => record.id || record.trace_id || Math.random().toString()}
                                        size="small"
                                        bordered
                                        pagination={false}
                                        style={{ marginTop: 8, width: '100%' }}
                                    />
                                )}
                            </div>
                        )}
                    </div>
                ))}
                {total > 0 && (
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            alignItems: 'center',
                            marginTop: 16,
                            gap: 16,
                        }}
                    >
                        {/* 总共条数和每页条数选择器 */}
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8, color: '#666', fontSize: 14 }}>
                            <span>共 {total} 条</span>
                            <Select
                                value={pageSize}
                                onChange={(size) => {
                                    setPageSize(size);
                                    setCurrentPage(1);
                                    window.scrollTo({ top: 0, behavior: 'smooth' });
                                }}
                                size="small"
                                style={{ width: 110 }}
                                options={[
                                    { label: '20 条', value: 20 },
                                    { label: '50 条', value: 50 },
                                    { label: '100 条', value: 100 },
                                    { label: '200 条', value: 200 },
                                ]}
                            />
                        </div>

                        {/* 页码 */}
                        <Pagination
                            current={currentPage}
                            pageSize={pageSize}
                            total={total}
                            showSizeChanger={false}
                            onChange={(page) => {
                                setCurrentPage(page);
                                window.scrollTo({ top: 0, behavior: 'smooth' });
                            }}
                        />
                    </div>
                )}
            </Card>
            <Modal
                title="订舱"
                open={bookModalOpen}
                onOk={handleBookModalOk}
                onCancel={() => setBookModalOpen(false)}
                destroyOnClose
                maskClosable={false}
            >
                <Form form={bookForm} labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                    <Form.Item label="send_num" name="send_num" rules={[{ required: true, message: '请输入 send_num' }]}>
                        <InputNumber
                            style={{ width: '100%' }}
                            min={1}
                            step={1}
                            precision={0}
                            stringMode={false}
                            onChange={handleBookModalSendNumChange}
                            formatter={(value) =>
                                value === undefined || value === null || value === '' ? '' : String(value).replace(/[^\d]/g, '')
                            }
                            parser={(value) => (value ? value.replace(/[^\d]/g, '') : '')}
                        />
                    </Form.Item>
                    <Form.Item label="箱量" name="container_quantity" rules={[{ required: true, message: '请输入箱量' }]}>
                        <InputNumber
                            style={{ width: '100%' }}
                            min={1}
                            step={1}
                            precision={0}
                            stringMode={false}
                            onChange={handleBookModalQtyChange}
                            formatter={(value) =>
                                value === undefined || value === null || value === '' ? '' : String(value).replace(/[^\d]/g, '')
                            }
                            parser={(value) => (value ? value.replace(/[^\d]/g, '') : '')}
                        />
                    </Form.Item>
                    <Form.Item
                        label="每箱重量（Kg）"
                        extra={
                            <span style={{ fontSize: 12, color: '#888' }}>
                                共 {watchedSendNum || 1} 组，每组 {watchedQty || 1} 个重量；
                            </span>
                        }
                    >
                        <div style={{ maxHeight: 320, overflowY: 'auto', paddingRight: 4 }}>
                            {(bookWeightGroups.length > 0 ? bookWeightGroups : [[]]).map((group, gi) => (
                                <div key={gi} style={{ marginBottom: 10 }}>
                                    <div style={{ fontSize: 12, color: '#888', marginBottom: 2 }}>第 {gi + 1} 组</div>
                                    <Select
                                        mode="tags"
                                        value={group.map(String)}
                                        onChange={(vals) => {
                                            const next = bookWeightGroups.length > 0 ? [...bookWeightGroups] : [[]];
                                            next[gi] = (vals || []).map((v) => Number(String(v).trim())).filter((v) => !isNaN(v) && v > 0);
                                            setBookWeightGroups(next);
                                        }}
                                        tokenSeparators={[',', ' ']}
                                        style={{ width: '100%' }}
                                        placeholder={`为第 ${gi + 1} 组输入 ${watchedQty || 1} 个每箱重量，回车新增`}
                                        open={false}
                                        suffixIcon={null}
                                    />
                                </div>
                            ))}
                        </div>
                    </Form.Item>
                    {bookModalItem && !selectedRouteMap[bookModalItem.id] && (
                        <Form.Item label="日期" name="order_date" rules={[{ required: true, message: '请选择日期' }]}>
                            <DatePicker style={{ width: '100%' }} />
                        </Form.Item>
                    )}
                </Form>
            </Modal>
            <Modal
                title="批量获取约号"
                open={batchBookModalOpen}
                onOk={handleBatchBookModalOk}
                onCancel={() => setBatchBookModalOpen(false)}
                destroyOnClose
                maskClosable={false}
                confirmLoading={batchBookLoading}
            >
                <Form form={batchBookForm} labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                    <Form.Item label="send_num" name="send_num" rules={[{ required: true, message: '请输入 send_num' }]}>
                        <InputNumber
                            style={{ width: '100%' }}
                            min={1}
                            step={1}
                            precision={0}
                            stringMode={false}
                            formatter={(value) =>
                                value === undefined || value === null || value === '' ? '' : String(value).replace(/[^\d]/g, '')
                            }
                            parser={(value) => (value ? value.replace(/[^\d]/g, '') : '')}
                        />
                    </Form.Item>
                </Form>
            </Modal>
            <Modal
                title="创建自动订舱任务"
                open={autoBookModalOpen}
                onOk={handleAutoBookModalOk}
                onCancel={() => setAutoBookModalOpen(false)}
                destroyOnClose
                maskClosable={false}
                okText="创建"
                cancelText="取消"
                confirmLoading={autoBookLoading}
            >
                <Form form={autoBookForm} labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}>
                    <Form.Item label="约号" name="quotation_number">
                        <Input disabled />
                    </Form.Item>
                    <Form.Item label="最大尝试次数" name="max_attempts" rules={[{ required: true, message: '请输入最大尝试次数' }]}>
                        <InputNumber style={{ width: '100%' }} min={1} step={1} precision={0} />
                    </Form.Item>
                    <Form.Item label="目标下单数量" name="target_success_count" rules={[{ required: true, message: '请输入目标下单数量' }]}>
                        <InputNumber style={{ width: '100%' }} min={1} step={1} precision={0} />
                    </Form.Item>
                    <Form.Item label="间隔时间（秒）" name="interval_seconds" rules={[{ required: true, message: '请输入间隔时间' }]}>
                        <InputNumber style={{ width: '100%' }} min={1} step={1} precision={0} />
                    </Form.Item>
                    <Form.Item label="账号" name="account_name">
                        <Input disabled />
                    </Form.Item>
                    <Form.Item label="箱量" name="container_quantity" rules={[{ required: true, message: '请输入箱量' }]}>
                        <InputNumber style={{ width: '100%' }} min={1} step={1} precision={0} />
                    </Form.Item>
                </Form>
            </Modal>
            <Modal
                title="重量范围设置"
                open={weightRangeModalOpen}
                onOk={handleWeightRangeModalOk}
                onCancel={() => setWeightRangeModalOpen(false)}
                destroyOnClose
                maskClosable={false}
                okText="保存"
                cancelText="取消"
            >
                <Form form={weightRangeForm} labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}>
                    <div style={{ fontWeight: 600, marginBottom: 8 }}>单个箱子重量范围（Kg）</div>
                    <Form.Item label="最小值" name="single_min" rules={[{ required: true, message: '请输入最小值' }]}>
                        <InputNumber style={{ width: '100%' }} min={1} step={1} precision={0} />
                    </Form.Item>
                    <Form.Item label="最大值" name="single_max" rules={[{ required: true, message: '请输入最大值' }]}>
                        <InputNumber style={{ width: '100%' }} min={1} step={1} precision={0} />
                    </Form.Item>

                    <div style={{ fontWeight: 600, margin: '16px 0 8px' }}>多个箱子重量范围（Kg）</div>
                    <Form.Item label="最小值" name="multi_min" rules={[{ required: true, message: '请输入最小值' }]}>
                        <InputNumber style={{ width: '100%' }} min={1} step={1} precision={0} />
                    </Form.Item>
                    <Form.Item label="最大值" name="multi_max" rules={[{ required: true, message: '请输入最大值' }]}>
                        <InputNumber style={{ width: '100%' }} min={1} step={1} precision={0} />
                    </Form.Item>
                </Form>
            </Modal>
        </Form>
    );
}
